<template>
  <div class="appeal-detail">
    <h3>任务申诉详情</h3>
    <div class="mod">
      <dl class="cl">
        <dt class="fl">申诉编号：</dt>
        <dd>{{ appealInfo.complainId }}</dd>
      </dl>
      <dl class="cl">
        <dt class="fl">订单编号：</dt>
        <dd>{{ appealInfo.contractId }}</dd>
      </dl>
      <dl class="cl">
        <dt class="fl">申诉时间：</dt>
        <dd>{{ appealInfo.complainTime }}</dd>
      </dl>
      <dl class="cl">
        <dt class="fl">申诉状态：</dt>
        <dd>{{ map.appeal.status[appealInfo.complainStatus] }}</dd>
      </dl>
      <dl class="cl">
        <dt class="fl">结算金额：</dt>
        <dd>{{ appealInfo.amount }}</dd>
      </dl>
      <dl v-if="appealInfo.complainStatus === 2" class="cl">
        <dt class="fl">驳回理由：</dt>
        <dd>{{ appealInfo.platformOpinion }}</dd>
      </dl>
      <template v-if="appealInfo.complainStatus === 6">
        <dl class="cl">
          <dt class="fl">申诉结果：</dt>
          <dd>{{ map.appeal.result[appealInfo.platformResults] }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">平台处理意见：</dt>
          <dd>{{ appealInfo.platformOpinion }}</dd>
        </dl>
      </template>
    </div>
    <div class="detail cl">
      <div class="mod fl">
        <h4>申诉方</h4>
        <dl class="cl">
          <dt class="fl">申诉人：</dt>
          <dd>{{ appealInfo.partyAName }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">申诉类型：</dt>
          <dd>{{ map.appeal.type[appealInfo.complainType] }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">申诉内容：</dt>
          <dd>{{ appealInfo.complainContent }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">申诉诉求：</dt>
          <dd>{{ map.appeal.result[appealInfo.expectedResults] }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">申诉举证：</dt>
          <dd>
            <ul>
              <li v-for="file in appealInfo.complainCertificateA">
                <a :href="getDownloadUrl(file.url, file.name)">{{
                  file.name
                }}</a>
              </li>
            </ul>
          </dd>
        </dl>
      </div>
      <div class="mod fr">
        <h4>被申诉方</h4>
        <dl class="cl">
          <dt class="fl">被申诉人：</dt>
          <dd>{{ appealInfo.partyBName }}</dd>
        </dl>
        <dl class="cl">
          <dt class="fl">是否认可申诉：</dt>
          <dd>{{ map.appeal.agreeStatus[appealInfo.acceptStatus] }}</dd>
        </dl>
        <template v-if="appealInfo.acceptStatus === 3">
          <dl class="cl">
            <dt class="fl">不认可理由：</dt>
            <dd>{{ appealInfo.rejectReason }}</dd>
          </dl>
          <dl class="cl">
            <dt class="fl">不认可举证：</dt>
            <dd>
              <ul>
                <li v-for="file in appealInfo.complainCertificateB">
                  <a :href="getDownloadUrl(file.url, file.name)">{{
                    file.name
                  }}</a>
                </li>
              </ul>
            </dd>
          </dl>
        </template>
      </div>
    </div>
    <el-button-group>
      <el-button
        type="primary"
        :disabled="appealInfo.complainStatus !== 1"
        @click="toggleDialog('accept')"
        >受理申诉</el-button
      >
      <el-button
        type="primary"
        :disabled="appealInfo.complainStatus !== 1"
        @click="toggleDialog('reject')"
        >驳回申诉</el-button
      >
      <el-button
        type="primary"
        :disabled="appealInfo.complainStatus !== 4"
        @click="toggleDialog('finish')"
        >结束申诉单</el-button
      >
    </el-button-group>
    <el-dialog title="是否确认受理该申诉单？" :visible.sync="dialog.accept">
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="update('accept')">确 认</el-button>
        <el-button @click="toggleDialog('accept')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="是否确认驳回该申诉单？" :visible.sync="dialog.reject">
      <el-form :model="reject" ref="reject">
        <el-form-item
          prop="option"
          :rules="[
            {
              required: true,
              message: '请填写驳回理由',
            },
          ]"
        >
          <el-input
            type="textarea"
            placeholder="请填写驳回理由"
            :rows="3"
            v-model.trim="reject.option"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit('reject')">确 认</el-button>
        <el-button @click="toggleDialog('reject')">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="是否确认结束该申诉单？" :visible.sync="dialog.finish">
      <el-form :model="finish" ref="finish">
        <el-form-item
          prop="platformResults"
          :rules="[
            {
              required: true,
              message: '选择平台处理结果',
            },
          ]"
        >
          <el-select
            v-model="finish.platformResults"
            placeholder="选择平台处理结果"
          >
            <el-option
              v-for="(label, value) in map.appeal.result"
              :key="value"
              :label="label"
              :value="value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="option"
          :rules="[
            {
              required: true,
              message: '填写平台处理意见',
            },
          ]"
        >
          <el-input
            type="textarea"
            placeholder="填写平台处理意见"
            :rows="3"
            v-model.trim="finish.option"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit('finish')">确 认</el-button>
        <el-button @click="toggleDialog('finish')">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";
const { appeal } = api;

export default {
  name: "taskAppealsDetail",
  data() {
    return {
      map,
      appealInfo: {},
      dialog: {
        accept: false,
        reject: false,
        finish: false,
      },
      reject: {
        option: "",
      },
      finish: {
        option: "",
        platformResults: "",
      },
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  watch: {},
  mounted() {
    this.getDetail();
  },
  methods: {
    getDownloadUrl(url, name) {
      return `${url}?attname=${encodeURIComponent(name)}`;
    },
    toggleDialog(name) {
      this.dialog[name] = !this.dialog[name];
    },
    async getDetail() {
      let {
        data: { code, data },
      } = await appeal.detail({
        complainId: this.id,
      });
      if (code == 200) {
        this.appealInfo = data;
      }
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.update(formName);
        } else {
          return false;
        }
      });
    },
    async update(action) {
      let status = 4;
      let obj = {
        complainId: this.id,
      };
      switch (action) {
        case "accept":
          status = 4;
          break;
        case "reject":
          status = 2;
          obj.option = this.reject.option;
          break;
        case "finish":
          status = 6;
          obj.option = this.finish.option;
          obj.platformResults = this.finish.platformResults;
          break;
        default:
      }
      obj.complainStatus = status;
      let res = await appeal.updateStatus(obj);
      this.getDetail();
      this.toggleDialog(action);
    },
  },
};
</script>
<style scoped>
.appeal-detail .mod {
  width: 45%;
  font-size: 14px;
}

.appeal-detail .detail {
  margin-top: 30px;
  border-top: solid 1px #e6e6e6;
}

.appeal-detail .mod dt {
  width: 120px;
}

.appeal-detail .mod dd {
  overflow: hidden;
}

.appeal-detail .el-button-group {
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/taskManage/appealsDetail.vue